import script from "./OrderAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./OrderAttachment.vue?vue&type=style&index=0&id=5f06a3f1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f06a3f1"]])

export default __exports__